<template>
  <div id="app">
    <component v-if="$route.name !== 'AlianzaLima'" :is="layout">
      <router-view/>
    </component>
    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import layoutDefault from './layout/default.vue';
import layoutDefaultMobile from './layout/defaultMobile.vue';
import { getCountries } from './utils';

export default {
  components: {
    layoutDefault,
    layoutDefaultMobile,
  },
  computed: mapState(['layout']),
  // mounted(){
  //   const script = document.createElement('script');
  //   script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_GOOGLE_RECAPCHA_SITE_KEY}`;
  //   script.async = true;
  //   document.body.appendChild(script);
  // }
  async mounted() {
    const countries = await getCountries();
    if (countries) this.$store.commit('setCountries', countries);
  },
};
</script>
